import { createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

export interface PlaceProfileUpdatedPayload extends TimestampPayload {
  placeUuid: string;
}
export const profileUpdated = createAction<PlaceProfileUpdatedPayload>('PLACE_PROFILE_UPDATED');
